import { getRequest } from "./config/request";
const SERVICE_URL = "/client";

export const getAll = () => getRequest(`${SERVICE_URL}/all`);
export const getByAliases = (aliases: string[]) =>
  getRequest(`${SERVICE_URL}/aliases?aliases=${aliases.join(",")}`);

export default { getAll };
